import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { ApiService } from "../services/api.service";

@Component({
  selector: 'app-join-meeting',
  templateUrl: './join-meeting.component.html',
  styleUrls: ['./join-meeting.component.css']
})
export class JoinMeetingComponent implements OnInit {
  meetingID:any;
  password:any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public ApiServiceCall: ApiService,

  ) {
this.meetingID;
this.password;

   }

  ngOnInit(): void {
  }

  onJoinMeeting() {

    var obj = {
      meetingId: this.meetingID,
      password: this.password,
      isAudioEnabled: 1,
      isVideoEnabled: 1
      };
      this.ApiServiceCall.joinMeeting(obj).subscribe((data) => {
     
        this.router.navigate(['meeting/'+this.meetingID]);
        
    });
   
    }
  
}
